"use client";

import * as React from "react";
import { ServerCrash } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Sentry } from "@/lib/sentry-client";
import { ErrorPageLayout } from "./components/ErrorPageLayout";

interface ServerErrorPageProps {
  error?: Error;
  reset?: () => void;
}

export function ServerErrorPage({ error, reset }: ServerErrorPageProps) {
  const { t } = useTranslation("common");

  React.useEffect(() => {
    if (error) {
      console.error("Server Error:", error);
      Sentry.captureException(error);
    }
  }, [error]);

  return (
    <ErrorPageLayout
      code="500"
      title={t("errors.server.title")}
      description={t("errors.server.description")}
      icon={ServerCrash}
      showRetry={true}
      onRetry={reset || (() => window.location.reload())}
      showGoBack={true}
      retryLabel={t("errors.server.retry")}
      backHomeLabel={t("errors.server.backHome")}
      goBackLabel={t("errors.generic.goBack")}
    />
  );
}

export default ServerErrorPage;
